/* Fioridella · selector guiado de /pages/subscriptions (28-sep).
   Lee los datos que Liquid deja en <script type="application/json" data-fd-sel-datos>:
   precios, planes, variantes del regalo y sectores de entrega. No teclea ningún precio.
   Toda salida va por textContent: nombres y etiquetas vienen del admin. */
(function () {
  'use strict';

  var root = document.querySelector('[data-fd-sel]');
  var nodoDatos = document.querySelector('[data-fd-sel-datos]');
  if (!root || !nodoDatos) return;
  var D;
  try { D = JSON.parse(nodoDatos.textContent); } catch (e) { return; }
  var T = D.t || {};

  var hayRamo = D.ramo && D.ramo.variantes.some(function (v) { return v.disponible && v.planes.length; });
  /* 29-sep: cada orquídea trae `versiones` (Premium / Standard). Una versión cuenta si tiene plan o regalo. */
  function util(v) { return v.planes.length || v.regalo.length; }
  var orqs = (D.orquideas || []).map(function (o) {
    return { nombre: o.nombre, foto: o.foto, versiones: (o.versiones || []).filter(util) };
  }).filter(function (o) { return o.versiones.length; });
  if (!hayRamo && !orqs.length) return; /* se queda el teléfono */

  root.hidden = false;
  var sin = document.querySelector('[data-fd-sel-sin]');
  if (sin) sin.hidden = true;

  /* ---------- utilidades ---------- */
  function dinero(c) {
    var n = c / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function fmt(s, vals) {
    return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return vals[k] !== undefined ? vals[k] : m; });
  }
  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt !== undefined && txt !== null) n.textContent = txt;
    return n;
  }
  function minimo(arr) { return Math.min.apply(null, arr); }
  function ahorro(plan, base) {
    var p = Math.round((1 - plan / base) * 100);
    return p > 0 ? fmt(T.ahorro, { pct: p }) : '';
  }

  var pasos = {};
  root.querySelectorAll('[data-paso]').forEach(function (f) { pasos[f.getAttribute('data-paso')] = f; });

  var st = { que: null, talla: null, version: null, para: null, plan: null, plazo: null, zip: '', sector: undefined, ref: '', codigo: '' };

  /* Pinta las opciones de un paso como radios grandes. `ops` = [{valor, titulo, precio, linea, foto, off}] */
  function opciones(paso, ops, elegido, alCambiar) {
    var caja = pasos[paso].querySelector('[data-opciones]');
    caja.textContent = '';
    ops.forEach(function (o, i) {
      var id = 'fd-sel-' + paso + '-' + i;
      var lab = el('label', 'fd-sel__op' + (o.foto ? ' fd-sel__op--foto' : ''));
      lab.setAttribute('for', id);
      var inp = el('input');
      inp.type = 'radio'; inp.name = 'fd-' + paso; inp.id = id; inp.value = String(o.valor);
      inp.className = 'fd-sel__radio';
      if (o.off) inp.disabled = true;
      if (elegido !== null && String(elegido) === String(o.valor)) inp.checked = true;
      inp.addEventListener('change', function () { alCambiar(o.valor); });
      lab.appendChild(inp);
      if (o.foto) {
        var im = el('img', 'fd-sel__foto');
        im.src = o.foto; im.alt = ''; im.loading = 'lazy'; im.width = 120; im.height = 150;
        lab.appendChild(im);
      }
      var cuerpo = el('span', 'fd-sel__op-cuerpo');
      cuerpo.appendChild(el('span', 'fd-sel__op-titulo', o.titulo));
      if (o.precio) cuerpo.appendChild(el('span', 'fd-sel__op-precio', o.precio));
      if (o.linea) cuerpo.appendChild(el('span', 'fd-sel__op-linea', o.linea));
      lab.appendChild(cuerpo);
      caja.appendChild(lab);
    });
  }

  function mostrar(paso, si) {
    var f = pasos[paso];
    var antes = f.hidden;
    f.hidden = !si;
    if (si && antes && window.innerWidth < 990) {
      setTimeout(function () { f.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
    }
  }

  /* La orquídea escogida, ya con su versión: { nombre, foto, id, precio, planes, regalo }. Null si falta la
     versión y hay que escogerla. El nombre lleva la versión cuando hubo que escoger. */
  function orqActual() {
    if (st.que !== 'orq' || st.talla === null) return null;
    var o = orqs[st.talla], vs = o.versiones;
    var x = vs.length === 1 ? vs[0] : (st.version === null ? null : vs[st.version]);
    if (!x) return null;
    var nom = vs.length > 1 ? o.nombre + ' · ' + (T['version_' + x.clave] || x.clave) : o.nombre;
    return { nombre: nom, foto: o.foto, id: x.id, precio: x.precio, planes: x.planes, regalo: x.regalo };
  }
  function ramoVar() {
    return st.que === 'ramo' && st.talla !== null ? D.ramo.variantes[st.talla] : null;
  }
  function planesActuales() {
    var v = ramoVar(); if (v) return { base: v.precio, planes: v.planes };
    var o = orqActual(); if (o && st.para === 'mi') return { base: o.precio, planes: o.planes };
    return null;
  }

  /* ---------- zona por ZIP ----------
     Devuelve TODOS los sectores del ZIP, los sin código primero (el que cobra el checkout). Un ZIP con
     más de uno (00907: Condado y Miramar) se pregunta a la clienta con los nombres del sitio. */
  function sectoresDe(zip) {
    if (!/^\d{5}$/.test(zip)) return undefined;
    var hits = (D.sectores || []).filter(function (s) { return (s.zips || []).indexOf(zip) !== -1; });
    if (!hits.length) return null;
    return hits.sort(function (a, b) { return (a.codigo ? 1 : 0) - (b.codigo ? 1 : 0) || b.fee - a.fee; });
  }

  /* ---------- pasos ---------- */
  function pintarQue() {
    var ops = [];
    if (hayRamo) {
      var pr = [];
      D.ramo.variantes.forEach(function (v) { v.planes.forEach(function (p) { pr.push(p.precio); }); });
      ops.push({ valor: 'ramo', titulo: T.ramo, precio: T.desde + ' ' + dinero(minimo(pr)), linea: T.ramo_texto });
    }
    if (orqs.length) {
      var po = [];
      orqs.forEach(function (o) {
        o.versiones.forEach(function (x) {
          x.planes.forEach(function (p) { po.push(p.precio); });
          x.regalo.forEach(function (g) { po.push(Math.round(g.precio / g.meses)); });
        });
      });
      ops.push({ valor: 'orq', titulo: T.orquidea, precio: T.desde + ' ' + dinero(minimo(po)), linea: T.orquidea_texto });
    }
    opciones('que', ops, st.que, function (v) {
      st.que = v; st.talla = null; st.version = null; st.para = null; st.plan = null; st.plazo = null;
      pintarTalla(); pintarVersion(); todo();
    });
    if (ops.length === 1 && st.que === null) { st.que = ops[0].valor; pintarQue(); pintarTalla(); }
  }

  function pintarTalla() {
    if (!st.que) { mostrar('talla', false); return; }
    var ops;
    if (st.que === 'ramo') {
      ops = D.ramo.variantes.map(function (v, i) {
        return { valor: i, titulo: v.titulo, precio: dinero(v.precio), off: !v.disponible || !v.planes.length };
      });
    } else {
      ops = orqs.map(function (o, i) {
        var pr = [], sueltos = [];
        o.versiones.forEach(function (x) {
          sueltos.push(x.precio);
          x.planes.forEach(function (p) { pr.push(p.precio); });
        });
        return { valor: i, titulo: o.nombre, foto: o.foto,
                 precio: T.desde + ' ' + dinero(minimo(pr.length ? pr : sueltos)) };
      });
    }
    pasos.talla.querySelectorAll('[data-solo]').forEach(function (n) {
      n.hidden = n.getAttribute('data-solo') !== st.que;
    });
    opciones('talla', ops, st.talla, function (v) {
      st.talla = Number(v); st.version = null; st.para = null; st.plan = null; st.plazo = null;
      pintarVersion(); pintarPara(); pintarFrecuencia(); pintarPlazo(); todo();
    });
    mostrar('talla', true);
  }

  /* Premium / Standard. Solo aparece si la orquídea tiene más de una versión. */
  function versionesTalla() { return st.que === 'orq' && st.talla !== null ? orqs[st.talla].versiones : []; }
  function hayPasoVersion() { return versionesTalla().length > 1; }

  function pintarVersion() {
    var vs = versionesTalla();
    if (vs.length < 2) { mostrar('version', false); numerar(); return; }
    var ops = vs.map(function (x, i) {
      var pr = x.planes.map(function (p) { return p.precio; });
      return { valor: i, titulo: T['version_' + x.clave] || x.clave,
               precio: pr.length ? T.desde + ' ' + dinero(minimo(pr)) : dinero(x.precio),
               linea: T['version_' + x.clave + '_texto'] || '' };
    });
    opciones('version', ops, st.version, function (v) {
      st.version = Number(v); st.para = null; st.plan = null; st.plazo = null;
      pintarPara(); pintarFrecuencia(); pintarPlazo(); todo();
    });
    mostrar('version', true);
    numerar();
  }

  /* Los pasos después de la talla corren un número cuando aparece el de versión. */
  function numerar() {
    var extra = hayPasoVersion() ? 1 : 0;
    var n = pasos.para.querySelector('[data-num]'); if (n) n.textContent = String(3 + extra);
    var z = pasos.plazo.querySelector('[data-num]'); if (z) z.textContent = String(4 + extra);
  }

  function pintarPara() {
    var o = orqActual();
    if (!o) { mostrar('para', false); return; }
    var ops = [];
    if (o.planes.length) ops.push({ valor: 'mi', titulo: T.para_mi, linea: T.para_mi_texto });
    if (o.regalo.length) ops.push({ valor: 'regalo', titulo: T.para_regalo, linea: T.para_regalo_texto });
    if (ops.length === 1) st.para = ops[0].valor;
    opciones('para', ops, st.para, function (v) {
      st.para = v; st.plan = null; st.plazo = null;
      pintarFrecuencia(); pintarPlazo(); todo();
    });
    mostrar('para', true);
  }

  function pintarFrecuencia() {
    var pa = planesActuales();
    if (!pa) { mostrar('frecuencia', false); return; }
    pasos.frecuencia.querySelector('[data-num]').textContent = st.que === 'ramo' ? '3' : String(4 + (hayPasoVersion() ? 1 : 0));
    var ops = pa.planes.map(function (p) {
      return { valor: p.id, titulo: p.etiqueta, precio: dinero(p.precio) + ' ' + T.por_entrega, linea: ahorro(p.precio, pa.base) };
    });
    if (ops.length === 1) st.plan = ops[0].valor;
    opciones('frecuencia', ops, st.plan, function (v) { st.plan = Number(v); todo(); });
    mostrar('frecuencia', true);
  }

  function pintarPlazo() {
    var o = orqActual();
    if (!o || st.para !== 'regalo') { mostrar('plazo', false); return; }
    var ops = o.regalo.slice().sort(function (a, b) { return a.meses - b.meses; }).map(function (g) {
      return { valor: g.id, titulo: g.etiqueta, precio: dinero(g.precio), linea: ahorro(g.precio, o.precio * g.meses) };
    });
    if (ops.length === 1) st.plazo = ops[0].valor;
    opciones('plazo', ops, st.plazo, function (v) { st.plazo = Number(v); todo(); });
    mostrar('plazo', true);
  }

  /* ---------- resumen ---------- */
  var R = {
    vacio: root.querySelector('[data-vacio]'), lleno: root.querySelector('[data-lleno]'),
    item: root.querySelector('[data-item]'), ritmo: root.querySelector('[data-ritmo]'),
    precio: root.querySelector('[data-precio]'), desglose: root.querySelector('[data-desglose]'),
    extra: root.querySelector('[data-extra]'), boton: root.querySelector('[data-boton]'),
    error: root.querySelector('[data-error]'), zip: root.querySelector('[data-zip]'),
    zipSalida: root.querySelector('[data-zip-salida]')
  };

  function telefono(nodo) {
    if (!D.tel) return;
    nodo.appendChild(document.createTextNode(' '));
    var a = el('a', 'fd-sel__tel', D.tel);
    a.href = 'tel:' + D.tel_href;
    nodo.appendChild(a);
  }

  function fila(dt, dd, cls) {
    var d = el('div', cls || '');
    d.appendChild(el('dt', '', dt));
    d.appendChild(el('dd', '', dd));
    R.desglose.appendChild(d);
  }

  /* Devuelve los items para /cart/add.js, o null si falta algo. Pinta el resumen de paso. */
  function todo() {
    R.error.hidden = true;
    R.desglose.textContent = ''; R.desglose.hidden = true;
    R.extra.textContent = ''; R.ritmo.textContent = ''; R.precio.textContent = '';
    var items = null;
    var v = ramoVar(), o = orqActual();

    if (v) {
      R.item.textContent = fmt(T.ramo_item, { talla: v.titulo });
    } else if (o) {
      R.item.textContent = st.para === 'regalo' ? fmt(T.regalo_item, { orquidea: o.nombre }) : o.nombre;
    } else {
      R.item.textContent = '';
    }

    var pa = planesActuales();
    if (pa && st.plan !== null) {
      var p = pa.planes.filter(function (x) { return x.id === st.plan; })[0];
      if (p) {
        R.ritmo.textContent = p.etiqueta;
        R.precio.textContent = dinero(p.precio) + ' ' + T.por_entrega;
        var ex = el('a', '', T.mas_entrega);
        if (D.entrega_url) { ex.href = D.entrega_url; R.extra.appendChild(ex); } else { R.extra.textContent = T.mas_entrega; }
        items = [{ id: v ? v.id : o.id, quantity: 1, selling_plan: p.id }];
      }
    }

    if (o && st.para === 'regalo') {
      var g = o.regalo.filter(function (x) { return x.id === st.plazo; })[0];
      var hits = sectoresDe(st.zip);
      pintarSectores(hits);
      var z = hits ? (hits.length === 1 ? hits[0] : hits[st.sector]) : hits;
      var n = g ? g.meses - 1 : 0;
      R.zipSalida.textContent = '';
      R.zipSalida.className = 'fd-sel__zip-salida';
      if (hits === null || (z && !z.entrega && n > 0)) {
        R.zipSalida.classList.add('fd-sel__zip-salida--fuera');
        R.zipSalida.textContent = T.zip_fuera;
        telefono(R.zipSalida);
        z = null;
      } else if (z) {
        R.zipSalida.textContent = fmt(T.zip_zona, { zona: z.nombre, precio: dinero(z.fee) });
      }
      if (g) {
        R.ritmo.textContent = fmt(T.una_al_mes, { meses: g.meses });
        R.desglose.hidden = false;
        fila(fmt(T.linea_regalo, { plazo: g.etiqueta }), dinero(g.precio));
        if (z) {
          var fee = z.entrega ? z.entrega.precio : z.fee;
          if (n > 0) fila(fmt(T.linea_entregas, { n: n, zona: z.nombre, precio: dinero(fee) }), dinero(fee * n));
          /* Primera entrega: la cobra el checkout. Con código (Miramar) la zona cobra la tarifa sin
             código y el código la deja en la del sector; se aplica solo al salir hacia el carrito. */
          fila(z.codigo ? fmt(T.linea_primera_codigo, { codigo: z.codigo }) : T.linea_primera, dinero(z.fee));
          fila(T.linea_total, dinero(g.precio + fee * n + z.fee), 'fd-sel__total');
          if (!st.ref) st.ref = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
          /* Propiedades privadas (con _): no se enseñan en inglés en el carrito en español. El carrito pinta
             una sola nota traducida con ZIP y zona, y el pedido lleva el atributo «Gift delivery ZIP». */
          var props = { _zip: st.zip, _zona: z.nombre, _gift_ref: st.ref };
          var pg = { _zip: st.zip, _zona: z.nombre, _gift_ref: st.ref, _por_unidad: String(n) };
          if (n > 0) pg._deliv_id = String(z.entrega.id);
          /* Entregas primero en la llamada: Shopify pone arriba lo último añadido, y así el regalo queda
             encima de sus entregas en el carrito y en el checkout. */
          items = [];
          if (n > 0) items.push({ id: z.entrega.id, quantity: n, properties: props });
          items.push({ id: g.id, quantity: 1, properties: pg });
          st.codigo = z.codigo || '';
        } else if (hits === undefined) {
          R.extra.textContent = T.zip_pide;
        }
      }
    }

    /* 29-sep: «Datos de la entrega» aparece cuando ya hay algo que añadir, numerado después del último paso. */
    if (pasos.datos) {
      var visibles = Object.keys(pasos).filter(function (k) { return k !== 'datos' && !pasos[k].hidden; }).length;
      pasos.datos.querySelector('[data-num]').textContent = String(visibles + 1);
      if (items) { mostrar('datos', true); } else { pasos.datos.hidden = true; }
    }

    var hay = !!R.item.textContent;
    R.vacio.hidden = hay; R.lleno.hidden = !hay;
    R.boton.disabled = !items;
    R.boton._items = items;
    return items;
  }

  var cajaSect = root.querySelector('[data-sectores]');
  var sectPintados = '';
  function pintarSectores(hits) {
    if (!cajaSect) return;
    var clave = hits && hits.length > 1 ? st.zip : '';
    if (clave === sectPintados) return;
    sectPintados = clave;
    cajaSect.textContent = '';
    cajaSect.hidden = !clave;
    if (!clave) return;
    cajaSect.appendChild(el('p', 'fd-sel__sect-pregunta', T.zip_cual));
    var fila_ = el('div', 'fd-sel__opciones fd-sel__opciones--dos');
    hits.forEach(function (s, i) {
      var id = 'fd-sel-sect-' + i;
      var lab = el('label', 'fd-sel__op');
      lab.setAttribute('for', id);
      var inp = el('input');
      inp.type = 'radio'; inp.name = 'fd-sector'; inp.id = id; inp.value = String(i); inp.className = 'fd-sel__radio';
      inp.addEventListener('change', function () { st.sector = i; todo(); });
      lab.appendChild(inp);
      var c = el('span', 'fd-sel__op-cuerpo');
      c.appendChild(el('span', 'fd-sel__op-titulo', s.nombre));
      c.appendChild(el('span', 'fd-sel__op-precio', dinero(s.fee) + ' ' + T.por_entrega));
      if (s.codigo) c.appendChild(el('span', 'fd-sel__op-linea', fmt(T.con_codigo, { codigo: s.codigo })));
      lab.appendChild(c);
      fila_.appendChild(lab);
    });
    cajaSect.appendChild(fila_);
  }

  if (R.zip) {
    R.zip.addEventListener('input', function () {
      R.zip.value = R.zip.value.replace(/\D/g, '').slice(0, 5);
      if (st.zip !== R.zip.value) st.sector = undefined;
      st.zip = R.zip.value;
      todo();
    });
  }

  /* Los datos viajan con los mismos nombres de propiedad que la ficha, en la línea principal (la suscripción o el
     regalo; las entregas del regalo no llevan fecha propia). Se validan aquí porque el form lleva novalidate. */
  function datosValidos() {
    var campos = pasos.datos ? pasos.datos.querySelectorAll('[data-sel-dato]') : [];
    for (var i = 0; i < campos.length; i++) {
      if (!campos[i].checkValidity()) { campos[i].reportValidity(); return false; }
    }
    return true;
  }
  function datos() {
    var out = {};
    (pasos.datos ? pasos.datos.querySelectorAll('[data-sel-dato]') : []).forEach(function (c) {
      var v = (c.value || '').trim();
      if (v) out[c.getAttribute('data-sel-dato')] = v;
    });
    return out;
  }

  root.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var items = todo();
    if (!items) return;
    if (!datosValidos()) return;
    var d = datos(), principal = items[items.length - 1];
    principal.properties = Object.assign({}, principal.properties || {}, d);
    R.boton.disabled = true;
    var txt = R.boton.textContent;
    R.boton.textContent = T.boton_cargando;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      var raiz = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var carro = D.carrito || '/cart';
      /* Miramar: /discount/<código> es el mecanismo de Shopify que deja el código aplicado (el mismo
         botón «Apply MIRAMAR» del carrito). */
      window.location.href = st.codigo && items.length && items[items.length - 1].properties
        ? raiz + 'discount/' + encodeURIComponent(st.codigo) + '?redirect=' + encodeURIComponent(carro)
        : carro;
    }).catch(function () {
      R.boton.textContent = txt;
      R.boton.disabled = false;
      R.error.hidden = false;
      R.error.textContent = T.error;
      telefono(R.error);
    });
  });

  pintarQue();
  todo();
})();
